function parse_utm_data() {
  var url = new URL(window.location.href);
  var paramsToStore = [
    'utm_campaign',
    'utm_content',
    'utm_medium',
    'utm_source',
    'utm_term',
    'utm_adgroupid',
    'utm_campaignid',
    'utm_creative',
    'utm_device',
    'gclid',
    'utm_keyword',
    'utm_matchtype',
    'utm_network',
    'utm_targetid',
    'li_fat_id',
    'msclkid',
    'fbclid',
    'channel_type',
    'utm_gclid',
    'utm_adgroup',
    'leadsource',
    'ft_utm_campaign',
    'ft_utm_content',
    'ft_utm_medium',
    'ft_utm_source',
    'ft_utm_term',
    'ft_utm_adgroupid',
    'ft_utm_campaignid',
    'ft_utm_creative',
    'ft_utm_device',
    'ft_gclid',
    'ft_utm_keyword',
    'ft_utm_matchtype',
    'ft_utm_network',
    'ft_utm_targetid',
    'ft_li_fat_id',
    'ft_msclkid',
    'ft_fbclid',
    'ft_channel_type',
    'ft_sfcid',
    'whitepaper',
    'honeypot',
    'CampaignId',
    'status',
    'leadsource',
    'ft_utm_source',
    'ft_utm_medium',
    'ft_utm_campaign',
    'Chilipiper_Campaign_Member_Status',
    'chilipiper_meeting_topic',
    'Chilipiper_CampaignID',
    'booking_popup',
  ];
  for(var i in paramsToStore) {
    if(!!url.searchParams.get(paramsToStore[i])) {
      window.localStorage.setItem(paramsToStore[i], url.searchParams.get(paramsToStore[i]));
    }
  }
  var currentReferrer = document.referrer || 'null';
  var refDomains = {
    '://google.com ': ['google', 'organic'],
    '://bing.com ': ['bing', 'organic'],
    '://linkedin.com ': ['linkedin', 'organic'],
    'x.com': ['x', 'organic'],
    '://instagram.com ': ['instagram', 'organic'],
    '://facebook.com ': ['facebook', 'organic'],
    '://greensheet.com ': ['greensheet', 'referral'],
    '://yahoo.com ': ['yahoo', 'organic'],
    'reddit.com': ['reddit', 'organic']
  };

  var ft_utm_Source = 'Web';
  var ft_utm_Medium = 'direct';
  for (var domain in refDomains) {
    if (currentReferrer.includes(domain)) {
      ft_utm_Source = refDomains[domain][0];
      ft_utm_Medium = refDomains[domain][1];
    }
  }

  if(!!window.localStorage.getItem('ft_utm_Source')){
    window.localStorage.setItem('ft_utm_Source', ft_utm_Source);
  }

  if(!!window.localStorage.getItem('ft_utm_Medium')){
    window.localStorage.setItem('ft_utm_Medium', ft_utm_Medium);
  }
}

parse_utm_data();
